if(!customElements.get('collection-pincode-check')){
    class CollectionPincodeCheck extends HTMLElement{
        constructor(){
            super();
            this.collectionPincodeCheckWrapper = this.querySelector('.collection_pincode-check_wrapper');
            this.collectionPincodeBottomPopup = this.querySelector('.collection_pincode-bottom_popup');
            this.collectionPincodeFirstWrapper = this.querySelector('.collection_pincode-first_wrapper');
            this.collectionPincodeEnterWrapper = this.querySelector('.collection_pincode-enter_wrapper');
            this.collectionPincodeCurrentWrapper = this.querySelector('.collection_pincode-current_wrapper');
            this.collectionPincodeInputWrapper = this.querySelector('.collection_pincode-input_wrapper');
            this.collectionPincodeInputBackWrapper = this.querySelector('.collection_pincode-input_back_wrapper');
            this.collectionPincodeCloseIcon = this.querySelector('.collection_pincode-close_icon');
            this.collectionPincodeCheckText = this.querySelector('.collection_pincode-check_text');
            this.desCollectionPincodeInput = this.querySelector('.des-collection_pincode-input');
            this.desCollectionPincodeCheck = this.querySelector('.des-collection_pincode-check');
            this.collectionPincodeCheckButton = this.querySelector('.collection_pincode-check_button');
            this.collectionPincodeInput = this.querySelector('#collectionPincodeInput');
            this.pincodeMsg = this.querySelector('.pincode-msg');
            this.pincode = sessionStorage.getItem('pincode') || null;
        }
        connectedCallback(){
            this.collectionPincodeCheckWrapper.addEventListener('click', () => {
               this.collectionPincodeBottomPopup.classList.remove('hidden');
            });
            this.collectionPincodeEnterWrapper.addEventListener('click', () => {
                this.collectionPincodeFirstWrapper.classList.add('hidden');
                this.collectionPincodeInputWrapper.classList.remove('hidden');
            })
            this.collectionPincodeInputBackWrapper.addEventListener('click', () => {
                this.collectionPincodeInputWrapper.classList.add('hidden');
                this.collectionPincodeFirstWrapper.classList.remove('hidden');
            });
            this.collectionPincodeCloseIcon.addEventListener('click', () => {
                this.collectionPincodeBottomPopup.classList.add('hidden');
            });
            this.collectionPincodeCheckButton.addEventListener('click', () => {
                let pincode = this.collectionPincodeInput.value;
                if(/^\d{6}$/.test(pincode)){
                    this.pincode = pincode;
                    this.collectionPincodeCheckText.innerText = `Deliver to ${this.pincode}`;
                    this.collectionPincodeCheckButton.classList.add('spinner-loading')
                    this.getServiceability();
                }else{
                    this.userMessage("Please enter a valid pincode!");
                }
                setTimeout(() => {
                    this.collectionPincodeCheckButton.classList.remove('spinner-loading')
                    this.collectionPincodeInput.value = '';
                }, 2000);
            });
            this.desCollectionPincodeCheck.addEventListener('click', () => {  
                let pincode = this.desCollectionPincodeInput.value;
                if(/^\d{6}$/.test(pincode)){
                    this.pincode = pincode;
                    this.getServiceability();
                    this.desCollectionPincodeCheck.classList.add('spinner-loading');
                }
                setTimeout(() => {
                    this.desCollectionPincodeCheck.classList.remove('spinner-loading');
                }, 2000);
            });
            this.desCollectionPincodeInput.addEventListener('input', (e) => {
                e.target.value = e.target.value.slice(0, 6);   
            });
            this.collectionPincodeCurrentWrapper.addEventListener('click', () => {
                this.getPincode();
            });
            if(this.pincode){
                this.collectionPincodeCheckText.innerText = `Deliver to ${this.pincode}`;
                this.desCollectionPincodeInput.value = this.pincode;
            } else {
                this.desCollectionPincodeInput.value = '';
            }
        }

        getServiceability(){
            if(!this.pincode){
                return;
            }
          sessionStorage.setItem('pincode',this.pincode);
          setTimeout(() => {
            this.collectionPincodeFirstWrapper.classList.remove('hidden');
            this.collectionPincodeInputWrapper.classList.add('hidden');
            this.collectionPincodeBottomPopup.classList.add('hidden');
            }, 2000);
           //searchtap functionality
        }

        getPincode() {
            const storedLat = sessionStorage.getItem('latitude');
            const storedLng = sessionStorage.getItem('longitude');
            if (storedLat && storedLng) {
              this.getPincodeFromCoords(parseFloat(storedLat), parseFloat(storedLng));
            } else {
              // Fetch coordinates and store them
              navigator.geolocation.getCurrentPosition(
                (position) => {
                  const lat = position.coords.latitude;
                  const lng = position.coords.longitude;
                  // Store in sessionStorage
                  sessionStorage.setItem('latitude', lat);
                  sessionStorage.setItem('longitude', lng);
                  this.getPincodeFromCoords(lat,lng);
                },
                (error) => {
                  console.error(error);
                  this.userMessage("Please enable location permission from settings and try again!");
                }
              );
            }
        }

        async getPincodeFromCoords(lat,lng){
            if(!lat || !lng){
                this.userMessage("Unable to fetch pincode. Please try again later.");
                return
            };
            const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=AIzaSyBor61Uz7MhfKWKeF-OwNqqSv4i70OSe5U`;
            try {
                let response = await fetch(url);
                let data = await response.json();
                if (data.status === "OK") {
                    const result = data.results[0];
                    this.pincode = this.extractPostalCode(result.address_components);
                    this.collectionPincodeCheckText.innerText = `Deliver to ${this.pincode}`;
                    this.getServiceability();
                } else {
                    this.userMessage("Unable to fetch pincode. Please try again later.");
                }
            } catch (error) {
                this.userMessage("Error fetching geolocation data.");
            }
        }

        extractPostalCode(components) {
            const comp = components.find(c => c.types.includes("postal_code"));
            return comp ? comp.long_name : null;
        }

        userMessage(msg){
            this.pincodeMsg.textContent = msg;
            this.pincodeMsg.classList.add('error');
            setTimeout(() => {
                this.pincodeMsg.textContent = ""
                this.pincodeMsg.classList.remove('error');
            }, 3000);
        }
    }
    customElements.define('collection-pincode-check', CollectionPincodeCheck);
}